import React from "react";
import { Box } from "@mui/material";
import { SearchField } from "../../../../../../components/ui";
import { FilterableTextField } from "../filterable-text-field";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    filter: string;
    setFilter: (filter: string) => void;
    uniqueActives?: string[];
    previousFilters?: string[];
    onApplyFilters?: (selectedFilters: string[]) => void;
    filterKey: string;
    setFilterKey: (key: string) => void;
}

/** Painel de aba da listagem de ativos orais (busca + conteúdo). */
function OralTabPanel(props: TabPanelProps) {
    const { children, value, index, filter, setFilter, filterKey, setFilterKey, uniqueActives, onApplyFilters, ...other } = props;

    return (
        <div
            style={{ width: "100%" }}
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ mt: "8px" }}>
                    {onApplyFilters && uniqueActives ? (
                        <FilterableTextField
                            uniqueActives={uniqueActives}
                            onApplyFilters={onApplyFilters}
                            previouslySelectedFilters={props.previousFilters}
                            filter={filter}
                            setFilter={setFilter}
                            filterKey={filterKey}
                            setFilterKey={setFilterKey}
                        />
                    ) : (
                        <SearchField value={filter} onChange={setFilter} placeholder="Buscar..." />
                    )}
                    <Box sx={{ mt: "12px" }}>{children}</Box>
                </Box>
            )}
        </div>
    );
}

export default OralTabPanel;
